var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"terms-link",attrs:{"href":"/files/terms/250919_Política de Privacidade.pdf","target":"_blank"}},[_vm._v(" Termos de Uso "),_c('v-icon',{staticClass:"ml-1 align-icon text",attrs:{"x-small":"","color":"primary"}},[_vm._v("mdi-open-in-new")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }